var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", { attrs: { href: _vm.baseURL } }, [
    _c(
      "img",
      _vm._b(
        {
          staticClass: "logo",
          attrs: { src: require("../assets/logo.svg"), alt: "" },
        },
        "img",
        _vm.$attrs,
        false
      )
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }